const LIFESTYLE = [
    {
        value: 'food',
        label: 'Food'
    },
    {
        value: 'water',
        label: 'Water'
    },
    {
        value: 'excretion',
        label: 'Bowel Movement'
    }
]

export default {
    option: {
        value: 'lifestyle',
        label: 'Lifestyle',

        children: [
            {
                value: 'logged',
                label: 'Has logged',

                select: {
                    children: LIFESTYLE,
                    multiple: true
                },

                match: (patient, args) => args.every((arg) => patient.count_event[arg] != null)
            },
            {
                value: 'not-logged',
                label: 'Has not logged',

                select: {
                    children: LIFESTYLE,
                    multiple: true
                },

                match: (patient, args) => args.some((arg) => patient.count_event[arg] == null)
            }
        ]
    }
}
